var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"my-20 desktop-container"},[_c('div',{staticClass:"grid grid-cols-2 gap-6 lg:grid-cols-4"},_vm._l((_vm.block.player),function(player){return _c('PlayerCard',{key:player._uid,attrs:{"player":player}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }